import { PdfCell } from './pdf-cell';

export class PdfRow {

    pdfCells: PdfCell[];

    constructor(pdfCells?: PdfCell[]) {
        this.pdfCells = [];
        if (pdfCells) {
            pdfCells.forEach(cell => this.pdfCells.push(cell));
        }
    }

    addCell(pdfCell: PdfCell) {
        this.pdfCells.push(pdfCell);
    }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/shared/pdf/pdf-row.ts